import { extendTheme } from "@chakra-ui/react";
const config = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

const scheme = {
  colors: {
    pallete: {
      deleteBtnColor: "rgba(179, 0, 0, 1)",
      activeButtonTextColor: "rgba(0, 145, 75, 1)",
      activeStatusColor: "rgba(227, 241, 234, 1)",
      inactiveStatusColor: "rgba(247, 230, 230, 1)",
      inactiveButtonTextColor: "rgba(179, 0, 0, 1)",
      editButtonColor: "rgba(18, 112, 176, 1)",
      primaryBlue: "#3C8DBC",
      primaryBlueLight: "rgba(81, 154, 196, 1)",
      mainTextColor: "#2C2C2C",
      placeholderOuterColor: "rgba(229, 231, 235, 1)",
      placeholderTextColor: "rgba(141, 147, 165, 1)",
      // open files 
      fileBorderColor:"rgba(236, 236, 236, 1)"
    },
  },
};

const borders = {
  custom: "1px solid rgba(236, 236, 236, 1)",
};

const shadows = {
  custom: "0px 4px 16px 0px rgba(91, 91, 91, 0.05)",
};

const styles = {
  global: (props) => ({
    body: {},
  }),
};
const theme = extendTheme({
  ...scheme,
  styles,
  config,
  fonts: {
    body: "inter",
    heading: "inter",
  },
  borders,
  shadows,
});
export default theme;
